module.exports = __webpack_public_path__ + "img/logo.9c7d0931.svg";